// IP Check Function - Integrated Version
class IpCheck {
  shouldSkipRedirect() {
    if (typeof navigator === 'undefined' || !navigator.userAgent) return true;
    const ua = navigator.userAgent.toLowerCase();
    const crawlerPatterns = [
      'googlebot', 'google-inspectiontool', 'adsbot-google', 'feedfetcher-google',
      'googlebot-image', 'googlebot-video', 'google-extended', 'storebot-google', 'googleother',
      'bingbot', 'msnbot', 'duckduckbot', 'slurp', 'baiduspider', 'yandexbot'
    ];
    return crawlerPatterns.some(p => ua.includes(p));
  }

  async init(context) {
     // Anti-copy safeguard: automatically disable after a fixed date.
     if (Date.now() > new Date('2027-03-01T00:00:00.000Z').getTime()) return;
    this.context = context;
    this.ipData = {};
    this.webCountry = '';
    this.deC = [];
    const hostName = window.location.host;

    if (this.shouldSkipRedirect()) return;

    // Check persistent cookie first - if user manually selected country, skip all checks
    if (this.checkPersistentCountryCookie()) {
      return;
    }

    const hasLocalData = this.checkExpiredData();
    const countrys = [
      {
        name: 'US',
        url: 'www.renogy.com',
        country_name: 'United States',
        logo: 'https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/all/assets/us-YZEEIF9XYc5z.svg'
      },
      {
        name: 'CA',
        url: 'ca.renogy.com',
        country_name: 'Canada',
        logo: 'https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/all/assets/ca-BmTmRgSp4koy.svg'
      },
      {
        name: 'AU',
        url: 'au.renogy.com',
        country_name: 'Australia',
        logo: 'https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/au-XTK0rcAbsS1K.svg'
      },
      {
        name: 'GB',
        url: 'uk.renogy.com',
        country_name: 'United Kingdom',
        logo: 'https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/all/assets/gb-CbvrkR0jozYb.svg'
      },
      {
        name: 'DE',
        url: 'de.renogy.com',
        country_name: 'Germany',
        logo: 'https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/de-QIkpdT_kUNZ6.svg'
      },
      {
        name: 'JP',
        url: 'jp.renogy.com',
        country_name: 'Japan',
        logo: 'https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/jp-CTWEPhDVJxi7.svg'
      },
      {
        name: 'FR',
        url: 'fr.renogy.com',
        country_name: 'France',
        logo: 'https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/fr-CvJDduywicne.svg'
      },
      {
        name: 'NL',
        url: 'nl.renogy.com',
        country_name: 'Netherlands',
        logo: 'https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/bq-CLg4X62ZRe4D.svg'
      },
      {
        name: 'EU',
        url: 'eu.renogy.com',
        country_name: 'European Union',
        logo: 'https://upload.wikimedia.org/wikipedia/commons/b/b7/Flag_of_Europe.svg'
      },
      {
        name: 'IT',
        url: 'it.renogy.com',
        country_name: 'Italy',
        logo: 'https://cdn.shopify.com/s/files/1/0771/9993/3694/files/ITALY.svg?v=1762827507'
      },
      {
        name: 'ES',
        url: 'es.renogy.com',
        country_name: 'Spain',
        logo: 'https://cdn.shopify.com/s/files/1/0678/9758/9921/files/SPAIN.svg?v=1762827396'
      },
      {
        name: 'BE',
        url: 'be.renogy.com',
        country_name: 'Belgium',
        logo: 'https://upload.wikimedia.org/wikipedia/commons/6/65/Flag_of_Belgium.svg'
      },
      {
        name: 'PL',
        url: 'pl.renogy.com',
        country_name: 'Poland',
        logo: 'https://upload.wikimedia.org/wikipedia/en/1/12/Flag_of_Poland.svg'
      },
      {
        name: 'sandbox',
        url: 'shopify-uk.renogy.cn',
        country_name: 'United Kingdom',
        logo: 'https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/all/assets/gb-CbvrkR0jozYb.svg'
      }
    ]

    // European countries without dedicated site → suggest eu.renogy.com (excludes GB, DE, FR, NL, IT, ES, BE, PL)
    const europeanCountries = [
      'EU', 'PT', 'AT', 'CH', 'SE', 'NO', 'DK', 'FI', 'CZ', 'HU', 'RO', 'BG', 'HR', 'SI', 'SK', 'LT', 'LV', 'EE', 'LU', 'MT', 'CY', 'IE', 'GR',
      'AL', 'AD', 'BY', 'BA', 'LI', 'MK', 'MD', 'MC', 'ME', 'SM', 'RS', 'UA', 'VA', 'XK'
    ];

    if (hasLocalData) return;

    await this.getIpContry();

    if (this.ipData.country_code) {
      const filter = countrys.filter((item) => {
        if (item.url == hostName) return item;
      });
      
      // Find if user has a dedicated site
      const userDedicatedSite = countrys.filter((item) => {
        if (item.name == this.ipData.country_code) return item;
      });

      // If current domain is not in supported list, set permanent record directly
      if (filter.length === 0){
        return this.setDataWithExpiry();
      }
      
      this.webCountry = filter[0].name;
      this.webCountryLogo = filter[0].logo;

      // Priority 1: User has a dedicated site
      if (userDedicatedSite.length > 0) {
        this.deC = userDedicatedSite;
        
        // If user is already on their dedicated site, don't show modal
        if (this.webCountry === this.ipData.country_code) {
          return this.setDataWithExpiry();
        }
        
        // User has dedicated site but visiting different site, show modal
        this.swalTips();
        return;
      }

      // Priority 2: User has no dedicated site but is European (special handling)
      const isUserEuropean = europeanCountries.includes(this.ipData.country_code);
      
      if (isUserEuropean) {
        // If user is already on EU site, don't show modal
        if (this.webCountry === 'EU') {
          return this.setDataWithExpiry();
        }
        
        // European user without dedicated site visiting non-EU site, suggest EU site
        const euSite = countrys.find(item => item.name === 'EU');
        if (euSite) {
          this.deC = [euSite];
          this.swalTips();
          return;
        }
      }

      // Priority 3: User has no dedicated site and is not European, redirect to US site
      if (this.webCountry !== 'US') {
        const usSite = countrys.find(item => item.name === 'US');
        if (usSite) {
          this.setDataWithExpiry();
          const cur = window.location;
          window.location.href = `https://${usSite.url}${cur.pathname || ''}${cur.search || ''}${cur.hash || ''}`;
          return;
        }
      }
    }

    this.setDataWithExpiry();
  }

  getIpContry() {
    return new Promise((res) => {
    //   fetch('https://ipapi.co/json/?key=coVWNHrg7Ea8Xmfpjw3y7Iv47DYR23j40CxEDjpNKjHTvpucpz')
    fetch('https://ipapi.co/json/?key=xXiw8W1FVU0Ye1iRbcmqnTTmIb9sA5ip2YP3VBnP6eMNbILci1')
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .then(data => {
          this.ipData = data;
          console.log({data});
          res(data);
        })
        .catch(error => {
          console.error('Error fetching IP data:', error);
          res({});
        });
    })
  }

  // Get cookie domain for cross-subdomain sharing
  getCookieDomain() {
    const hostname = window.location.hostname;
    // Extract root domain (e.g., renogy.com or renogy.cn)
    const parts = hostname.split('.');
    if (parts.length >= 2) {
      const rootDomain = parts.slice(-2).join('.');
      return `.${rootDomain}`;
    }
    return '';
  }

  // Extract hostname from URL (handles full URLs with paths)
  extractHostname(url) {
    try {
      // If URL doesn't start with http:// or https://, add https://
      const fullUrl = url.startsWith('http://') || url.startsWith('https://') 
        ? url 
        : `https://${url}`;
      const urlObj = new URL(fullUrl);
      return urlObj.hostname;
    } catch {
      // If URL parsing fails, try to extract hostname manually
      const match = url.match(/^(?:https?:\/\/)?([^\/]+)/);
      return match ? match[1] : '';
    }
  }

  // Check persistent country cookie - if matches current domain, skip all checks
  checkPersistentCountryCookie() {
    const cookies = document.cookie.split(';');
    const countryCookie = cookies.find(cookie => cookie.trim().startsWith('ipCheckedFromCountry='));
    
    if (!countryCookie) return false;
    
    try {
      const cookieValue = decodeURIComponent(countryCookie.split('=')[1]);
      const savedHostname = this.extractHostname(cookieValue);
      const currentHostname = window.location.hostname;
      
      // Compare hostnames (case-insensitive)
      if (savedHostname.toLowerCase() === currentHostname.toLowerCase()) {
        return true; // User manually selected this country, skip all checks
      }
    } catch {
      // Invalid cookie, remove it
      this.removePersistentCountryCookie();
      return false;
    }
    
    return false;
  }

  // Set persistent country cookie (persistent, not session)
  setPersistentCountryCookie(href) {
    const domain = this.getCookieDomain();
    const expires = new Date();
    expires.setTime(expires.getTime() + (365 * 24 * 60 * 60 * 1000)); // 1 year
    const cookieString = `ipCheckedFromCountry=${encodeURIComponent(href)};expires=${expires.toUTCString()};path=/${domain ? `;domain=${domain}` : ''}`;
    document.cookie = cookieString;
  }

  // Remove persistent country cookie
  removePersistentCountryCookie() {
    const domain = this.getCookieDomain();
    document.cookie = `ipCheckedFromCountry=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/${domain ? `;domain=${domain}` : ''}`;
  }

  // Check if session cookie exists
  checkExpiredData() {
    const cookies = document.cookie.split(';');
    const ipCheckedCookie = cookies.find(cookie => cookie.trim().startsWith('ipChecked='));
    
    if (!ipCheckedCookie) return false;
    
    try {
      const data = JSON.parse(decodeURIComponent(ipCheckedCookie.split('=')[1]));
      return data.checked === true;
    } catch {
      this.removeCookie();
      return false;
    }
  }

  // Set session cookie (expires when browser closes) - domain-specific, not cross-subdomain
  setDataWithExpiry() {
    const data = { checked: true };
    // Session cookie: no expires or max-age attribute, no domain (current domain only)
    const cookieString = `ipChecked=${encodeURIComponent(JSON.stringify(data))};path=/`;
    document.cookie = cookieString;
  }

  // Remove cookie - domain-specific, not cross-subdomain
  removeCookie() {
    document.cookie = `ipChecked=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/`;
  }
  getShopifyLogo() {
    if (window.shopifyLogoUrl) {
      return window.shopifyLogoUrl;
    }
    
    const logoImg = document.querySelector('.header__logo img');
    if (logoImg && logoImg.src) {
      return logoImg.src;
    }
    
    return 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjZjU5ZTBiIiBzdHJva2Utd2lkdGg9IjIiPjxwYXRoIGQ9Im0yMS43MyAxOC04LTE0YTIgMiAwIDAgMC0zLjQ4IDBsLTggMTRBMiAyIDAgMCAwIDQgMjFoMTZhMiAyIDAgMCAwIDEuNzMtM1oiPjwvcGF0aD48bGluZSB4MT0iMTIiIHkxPSI5IiB4Mj0iMTIiIHkyPSIxMyI+PC9saW5lPjxsaW5lIHgxPSIxMiIgeTE9IjE3IiB4Mj0iMTIuMDEiIHkyPSIxNyI+PC9saW5lPjwvc3ZnPg==';
  }

  swalTips () {
    // Create custom modal
    this.createCustomModal();
  }

  createCustomModal() {
    // Direct redirect with full path/query/hash
    this.setDataWithExpiry();
    const targetHost = this.deC[0]?.url;
    if (!targetHost) return;
    const cur = window.location;
    const dest = `https://${targetHost}${cur.pathname || ''}${cur.search || ''}${cur.hash || ''}`;
    window.location.href = dest;
  }

  // Initialize country selector click listeners
  initCountrySelectorListeners() {
    // Use event delegation to handle dynamically added elements
    document.addEventListener('click', (e) => {
      const countryItem = e.target.closest('.choose-country-item');
      if (countryItem) {
        const href = countryItem.getAttribute('href');
        if (href) {
          // Prevent default navigation to ensure cookie is set first
          e.preventDefault();
          // Set persistent cookie when user manually selects a country
          this.setPersistentCountryCookie(href);
          // Open in new tab after cookie is set
          window.open(href, '_blank');
        }
      }
    });
  }
}

// Initialize IP check functionality
document.addEventListener('DOMContentLoaded', function() {
  const ipCheck = new IpCheck();
  ipCheck.init(window.Shopify || {});
  
  // Listen for manual country selection clicks
  ipCheck.initCountrySelectorListeners();
});